// extracted by mini-css-extract-plugin
export default {"wrap":"lG-z","fullWidth":"mG-z","hideOnDesktop":"nG-z","content":"oG-z","hasOpenedNav":"pG-z","crumbsList":"qG-z","dropdownsWrap":"rG-z"};